import React, { useContext, useEffect, useState } from "react";
import ButtonAnimation from "../../../Resusable/ButtonAnimation";
import { createElement } from "react";
import { globalContext } from "../../../context/ContextProvider";
import { auctionTableComponents } from "../../../helpers/auctionTable";
import AuctionFilter from "../../commanPage/searchAndFilter/AuctionFilter";
import AuctionSearch from "../../commanPage/searchAndFilter/AuctionSearch";

function AuctionStatusDetail() {
  const { sellerHistoryPageButton, setSellerHistoryPageButton } =
    useContext(globalContext);
  const [searchData, setSearchData] = useState("");
  const [auctionFilter, setAuctionFilter] = useState("");

  useEffect(() => {
    setSearchData("");
  }, [sellerHistoryPageButton]);

  return (
    <div className="mt-1">
      <h4>Auction Details</h4>

      <div className="valign-wrapper space-between flex-wrap">
        <ButtonAnimation
          buttonPosition={sellerHistoryPageButton}
          setButtonPosition={setSellerHistoryPageButton}
        />
        <div className="valign-wrapper gap-1">
          <span
            className="input-field-style"
            style={{
              height: "40px",
              width: "220px",
              marginBottom: "1rem",
            }}
          >
            <img src="/images/urlIcon.png" alt="auctionLogo" width={25} />
            <AuctionFilter setAuctionFilter={setAuctionFilter} />
          </span>
          <div
            className="input-field-style "
            style={{
              height: "40px",
              width: "250px",
              marginBottom: "1rem",
            }}
          >
            <AuctionSearch
              searchData={searchData}
              setSearchData={setSearchData}
              placeholder={"Search"}
            />
          </div>
        </div>
      </div>
      {auctionTableComponents[sellerHistoryPageButton] &&
        createElement(auctionTableComponents[sellerHistoryPageButton], {
          searchData: searchData,
          auctionFilter: auctionFilter,
        })}
    </div>
  );
}

export default AuctionStatusDetail;
